"use strict";

angular.module('app.passwordReset.passwordResetSent.passwordResetSentController', [])
    .controller('app.passwordReset.passwordResetSent.passwordResetSentController', [
        '$scope', '$stateParams',
        function ($scope, $stateParams) {
            $scope.email = $stateParams.email;
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/passwordReset/passwordResetSent/passwordResetSentController.js